import { IconButton, InputAdornment, InputLabel, TextField, Typography, useTheme } from "@mui/material";
import { ErrorMessage, Field } from "formik";
import { useState } from "react";
import { EyeIcon } from "../svgIcon/EyeIcon";
import { HideEyeIcon } from "../svgIcon/HideEyeIcon";

const PasswordInput = ({ values, title, onChange, id, props, helperText, placeholder }) => {
  const theme = useTheme();
  const [passwordType, setPasswordType] = useState("password");

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  return (
    <>
      <InputLabel>
        {title}
        <Typography component="span" color="error.main">
          *
        </Typography>
      </InputLabel>
      <Field
        {...props}
        as={TextField}
        placeholder={placeholder}
        variant="outlined"
        fullWidth
        id={id}
        name={id}
        value={values?.id}
        onChange={onChange}
        type={passwordType}
        helperText={<ErrorMessage color="error" name={id} />}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => togglePassword()} title="eyeBtn">
                {passwordType === "password" ? (
                  <HideEyeIcon color={theme.palette.grey.g2} />
                ) : (
                  <EyeIcon color={theme.palette.grey.g2} />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};

export default PasswordInput;
